import { Component, OnInit, Input, Output, EventEmitter, ElementRef, Attribute } from '@angular/core';
import { FormControl, Validators, FormGroup, ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material';

//  <f-input required name="labname" 
//           [ngModel]="something" 
//           disabled="disabled"
//           placeholder="Lab setup"
//           minLength="2"
//           maxLength="10"
//           pattern="[a-zA-Z]*"
//           errMsgRequired="Required"
//           errMsg="Not a valid entry"></f-input>

@Component({
    selector: 'f-input',
    templateUrl: './input.component.html',
    styles: [`
        :host >>>  .mat-input-suffix .mat-icon {
            height: 18px;
            width: 18px;
            margin-bottom:8px;
        }
    `],
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: InputComponent, multi: true }
    ]
})
export class InputComponent implements OnInit {

    inputFormControl: any;
    fn: any;
    isRequired: boolean;
    showIcon: boolean = false;
    inputIcon: string;
    @Input() minLength: number;
    @Input() maxLength: number;
    @Input() errMsg: string;
    @Input() errMsgRequired: string;
    @Input() pattern: string;
    @Input() icon: string;
    @Output() inputChange = new EventEmitter<string>();

    constructor(iconRegistry: MatIconRegistry, sanitizer: DomSanitizer, private element: ElementRef,
        @Attribute('placeholder') public placeholder: String,
        @Attribute('required') public required: String,
        @Attribute('disabled') public disabled: String) {
        iconRegistry.addSvgIcon(
            'search',
            sanitizer.bypassSecurityTrustResourceUrl('assets/images/bds/icn_search.svg'));
    }

    ngOnInit() {

        const arr = [];
        this.isRequired = (this.required !== null) ? true : false;

        if (this.icon !== null) {
            switch (this.icon) {
                case 'search':
                    this.showIcon = true;
                    this.inputIcon = 'search';
                    break;
            }
        }

        if (this.required !== null) {
            arr.push(Validators.required);
        }

        if (this.minLength !== null) {
            arr.push(Validators.minLength(this.minLength));
        }

        if (this.maxLength !== null) {
            arr.push(Validators.maxLength(this.maxLength));
        }

        if (this.pattern !== null) {
            arr.push(Validators.pattern(this.pattern));
        }

        this.inputFormControl = (this.disabled === 'disabled') ? new FormControl({ value: '', disabled: true }) : new FormControl('', arr);
    }


    writeValue(value: any) {
        this.inputFormControl.setValue(value);
    }

    registerOnChange(fn: (value: any) => void) {
        this.fn = fn;
    }

    registerOnTouched() { }
}




// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/brds/widgets/forms/input/input.component.ts